import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/sticky-note': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 348.1c0 11-6.3 26.2-14.1 33.9l-83.9 83.9c-7.8 7.8-23 14.1-33.9 14.1h-268.1c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v268.1zM320 428.1l76.1-76.1h-76.1v76.1zM400 80h-352v352h224v-104c0-13.3 10.7-24 24-24h104v-224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/sticky-note.js
// module id = 1822
// module chunks = 0